import Avatar from './avatar';
export type { AvatarProps } from './avatar.types';

export default Avatar;
